/**
 * 初回流入元（utm_*）の保持
 * 登録完了時（sign_up）に「どの SNS 経由か」を結び付けるため、最初に来たときの UTM を
 * localStorage に30日間保存する。GA の有効・無効に関係なく動作する。
 */

import { pickUtmParams, UTM_KEYS } from "./monitoring";

const STORAGE_KEY = "kakumon_first_touch";
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

/** 保存値を読む。無い・壊れている・期限切れは null（ts を含む） */
function readStored(now: number): Record<string, string> | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    const ts = Number(parsed.ts);
    if (!Number.isFinite(ts) || now - ts > TTL_MS) return null;
    return parsed as Record<string, string>;
  } catch {
    return null;
  }
}

/** UTM が付いた流入を記録する（30日以内の既存値があれば初回流入を優先して上書きしない） */
export function recordFirstTouch(search: string, now: number = Date.now()): void {
  try {
    const utm = pickUtmParams(search);
    if (Object.keys(utm).length === 0) return;
    if (readStored(now)) return;
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...utm, ts: now }));
  } catch {
    // プライベートブラウズ等で保存できなくてもアプリを壊さない
  }
}

/** 30日以内の初回流入 UTM を返す（ts は除く）。無い・壊れている・期限切れは null */
export function getFirstTouch(now: number = Date.now()): Record<string, string> | null {
  const stored = readStored(now);
  if (!stored) return null;
  // 改ざんされた JSON の任意キーを GA に送らないよう、UTM 5種の文字列値だけに絞る
  const utm: Record<string, string> = {};
  for (const key of UTM_KEYS) {
    const v = stored[key];
    if (typeof v === "string" && v !== "") utm[key] = v.slice(0, 200);
  }
  return utm;
}
